const Text = {
  variants: {
    largeRegular: {
      fontSize: '16px',
      fontFamily: 'body',
    },
    story: {
      fontSize: '17px',
      fontFamily: 'body',
    },
    largeBold: {
      fontSize: '16px',
      fontFamily: 'body',
      fontWeight: 600,
    },
    mediumRegular: {
      fontSize: '14px',
      fontFamily: 'body',
    },
    mediumSemiBold: {
      fontSize: '14px',
      fontFamily: 'body',
      fontWeight: 600,
    },
    smallSemiBold: {
      fontSize: '12px',
      fontFamily: 'body',
      fontWeight: 600,
    },
  },
}

export default Text
